export default [{
  path: '/hbindex',
  name: 'hbindex',
  meta: {
    title: '首页'
  },
  component: () => import('@/pages/HBcallfee/blank')
}, {
  path: '/hbcallfee',
  name: 'hbcallfee',
  meta: {
    title: '中行喊你充话费话费'
  },
  component: () => import('@/pages/HBcallfee/Index')
}, {
  path: '/hbrechargeresult',
  name: 'hbrechargeresult',
  meta: {
    title: '充值结果',
    notShare: true
  },
  component: () => import('@/pages/HBcallfee/rechargeResult')
}, {
  path: '/hbbocorder',
  name: 'hbbocorder',
  meta: {
    title: '话费',
    notShare: true
  },
  component: () => import('@/pages/HBcallfee/bocOrderDetails')
}]



// WEBPACK FOOTER //
// ./src/router/HBindex.js